<template>
  <div class="w-100">
    <div class="uploaded-audio d-flex align-items-center justify-content-between mb-3">
      <div class="audio-info d-flex align-items-center" v-if="isPlaying === false">
        <div class="icon">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 19.1665C18.2007 19.1665 19.9639 17.3836 19.9639 15.1749L19.9771 7.19177C19.9771 4.9831 18.2007 3.2002 16 3.2002C13.7993 3.2002 12.0228 4.9831 12.0228 7.19177V15.1749C12.0228 17.3836 13.7993 19.1665 16 19.1665ZM23.0263 15.1749C23.0263 19.1665 19.6589 21.9606 16 21.9606C12.341 21.9606 8.97369 19.1665 8.97369 15.1749H6.71997C6.71997 19.712 10.3259 23.4641 14.6743 24.1161V28.4802H17.3257V24.1161C21.674 23.4774 25.28 19.7253 25.28 15.1749H23.0263Z"
              fill="#313C4E"
            />
          </svg>
        </div>
        <!-- 12 March 2021 17:43:05 -->
        <div class="text">
          <p class="title">{{ audioFile.startRecordTime | moment("DD MMMM YYYY H:m:s") }}</p>
          <p class="duration">
            Duration: <span>{{ fileDuration }}</span>
          </p>
        </div>
      </div>
      <div class="actions d-flex align-items-center" v-if="isPlaying === false">
        <div class="icon newplay" @click="Play">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.6666 27.4997L26.6666 19.9997L16.6666 12.4997V27.4997ZM19.9999 3.33301C10.7999 3.33301 3.33325 10.7997 3.33325 19.9997C3.33325 29.1997 10.7999 36.6663 19.9999 36.6663C29.1999 36.6663 36.6666 29.1997 36.6666 19.9997C36.6666 10.7997 29.1999 3.33301 19.9999 3.33301ZM19.9999 33.333C12.6499 33.333 6.66659 27.3497 6.66659 19.9997C6.66659 12.6497 12.6499 6.66634 19.9999 6.66634C27.3499 6.66634 33.3333 12.6497 33.3333 19.9997C33.3333 27.3497 27.3499 33.333 19.9999 33.333Z"
              fill="#FF077B"
            />
          </svg>
        </div>
        <p class="mb-0 title">Play</p>
      </div>
      <div class="playing-audio w-100" v-if="isPlaying === true">
        <div class="newpause" @click="Pause">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 32H22V16H18V32ZM24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM26 32H30V16H26V32Z" fill="#FF077B" />
          </svg>
        </div>
        <div class="w-100 player-container-wraper">
          <div id="audio-player-container" :style="'--seek-before-width' + seekBeforeWidth">
            <div><input type="range" ref="seekSlider" class="w-100 slider" id="seek-slider" max="100" value="0" /></div>
            <div style="text-align:left"><span id="start-time">0:00</span></div>
          </div>
        </div>
        <div class="seeker" v-if="0">
          <div class="player-controls scrubber">
            <!-- <div class="newtimeline">
              <div class="progress"></div>
            </div> -->
            <span id="seek-obj-container">
              <progress id="seek-bar" min="0" max="100" :value="currentprogressBar"></progress>
              <samp class="seekbar" id="seekbar-samp" v-bind:style="{ left: currentprogressBar + '%' }"></samp>
            </span>
            <small><span id="start-time">0:00</span></small>
            <!-- <small id="end-time" class="end-time"></small> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomAudioRecorder",
  props: ["audioSrc", "audioFile"],
  data() {
    return {
      recorder: null,
      isPlaying: false,
      newaudio: "",
      newaudioPlayer: "",
      fileDuration: "00:00",
      currentprogressBar: 0,
      progressBarInterval: null,
      startRecordTime: null,
      audioPlayerContainer: null,
      seekSlider: null,
      raf: null,
      seekBeforeWidth: 0,
    };
  },
  created() {
    if (this.raf) {
      cancelAnimationFrame(this.raf);
    }
    var this_outer = this;
    // console.log(this.audioFile);
    this.fileDuration = this.getTimeCodeFromNumer(this.audioFile.duration);
    setTimeout(() => {
      this_outer.initalizeAudio();
      this_outer.newaudio.addEventListener(
        "ended",
        () => {
          this_outer.newaudio.currentTime = 0;
          // this_outer.currentprogressBar = 0;
          clearInterval(this_outer.progressBarInterval);
          cancelAnimationFrame(this.raf);
          this_outer.isPlaying = false;
        },
        false
      );
    }, 100);
  },
  methods: {
    showRangeProgress(rangeInput) {
      if (rangeInput === this.seekSlider) {
        this.audioPlayerContainer.style.setProperty("--seek-before-width", (rangeInput.value / rangeInput.max) * 100 + "%");
      } else {
        this.seekBeforeWidth = (this.seekSlider.value / this.seekSlider.max) * 100;
        this.audioPlayerContainer.style.setProperty("--volume-before-width", (rangeInput.value / rangeInput.max) * 100 + "%");
      }
    },
    whilePlaying() {
      this.seekSlider.value = Math.floor(this.newaudio.currentTime);
      let sliderValue = (this.seekSlider.value / this.seekSlider.max) * 100;
      this.audioPlayerContainer.style.setProperty("--seek-before-width", `${sliderValue}%`);
      this.displayCurrentDuration();
      this.raf = requestAnimationFrame(this.whilePlaying);
    },
    calculateTime(secs) {
      const minutes = Math.floor(secs / 60);
      const seconds = Math.floor(secs % 60);
      const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
      return `${minutes}:${returnedSeconds}`;
    },
    displayCurrentDuration() {
      this.audioPlayerContainer.querySelector("#start-time").textContent = this.calculateTime(this.newaudio.currentTime);
    },
    Play() {
      this.isPlaying = true;
      cancelAnimationFrame(this.raf);
      setTimeout(() => {
        this.audioPlayerContainer = document.getElementById("audio-player-container");
        this.seekSlider = document.getElementById("seek-slider");
        // Inilize Player
        // console.log(this.newaudio.duration , "this.newaudio.duration")
        // console.log(this.audioFile.fileDuration , "this.audioFile.fileDuration")
        if (parseInt(this.newaudio.duration)) {
          this.seekSlider.max = Math.floor(this.newaudio.duration);
        } else {
          this.seekSlider.max = Math.floor(this.audioFile.duration);
        }

        this.newaudio.play();
        requestAnimationFrame(this.whilePlaying);
        this.seekSlider.addEventListener("input", () => {
          if (!this.newaudio.paused) {
            cancelAnimationFrame(this.raf);
          }
        });
        this.seekSlider.addEventListener("change", () => {
          this.newaudio.currentTime = this.seekSlider.value;
          if (!this.newaudio.paused) {
            requestAnimationFrame(this.whilePlaying);
          }
        });
      }, 500);
    },
    Pause() {
      this.newaudio.pause();
      this.isPlaying = false;
      cancelAnimationFrame(this.raf);
    },
    initalizeAudio() {
      this.newaudioPlayer = document.querySelector(".uploaded-audio");
      this.newaudio = new Audio(this.audioSrc);
      this.newaudio.onloadedmetadata = () => {
        if (!parseInt(this.audioFile.duration)) {
          if (this.newaudio.duration) {
            this.fileDuration = this.getTimeCodeFromNumer(this.newaudio.duration);
            this.audioFile.duration = this.newaudio.duration;
          } else {
            this.audioFile.duration = 0;
          }
        } else if (!this.newaudio.duration) {
          this.audioFile.duration = 0;
        }
      };
    },
    getTimeCodeFromNumer(num) {
      let seconds = parseInt(num) ? parseInt(num) : 0;
      let minutes = parseInt(seconds / 60);
      seconds -= minutes * 60;
      const hours = parseInt(minutes / 60);
      minutes -= hours * 60;

      if (hours === 0) return `${String(minutes).padStart(2, 0)}:${String(seconds % 60).padStart(2, 0)}`;
      return `${String(hours).padStart(2, 0)}:${minutes}:${String(seconds % 60).padStart(2, 0)}`;
    },
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            for (let key in event.data.settings) {
              this.response.settings[key] = event.data.settings[key];
            }
            this.$session.set("response", this.response);
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          }
        }
      },
      false
    );
  },
  beforeDestroy: function() {
    this.newaudio.pause();
    this.isPlaying = false;
    cancelAnimationFrame(this.raf);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
input[type="range"] {
  position: relative;
  -webkit-appearance: none;
  width: 48%;
  margin: 0;
  padding: 0;
  height: 19px;
  float: left;
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: #ff077b;
}
input[type="range"]::before {
  position: absolute;
  content: "";
  top: 8px;
  left: 0;
  width: var(--seek-before-width);
  height: 4px;
  background-color: #ff077b;
  cursor: pointer;
}
input[type="range"]::-webkit-slider-thumb {
  position: relative;
  -webkit-appearance: none;
  box-sizing: content-box;
  border: 1px solid #ff077b;
  height: 23px;
  width: 23px;
  border-radius: 50%;
  background-color: #ff077b;
  cursor: pointer;
  margin: -10px 0 0 0;
}
input[type="range"]:active::-webkit-slider-thumb {
  transform: scale(1.2);
  background: #ff077b;
}
input[type="range"]::-moz-range-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: #ff077b;
}
input[type="range"]::-moz-range-progress {
  background-color: #ff077b;
}
input[type="range"]::-moz-focus-outer {
  border: 0;
}
input[type="range"]::-moz-range-thumb {
  box-sizing: content-box;
  border: 1px solid #ff077b;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
}
input[type="range"]:active::-moz-range-thumb {
  transform: scale(1.2);
  background: #ff077b;
}
input[type="range"]::-ms-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: transparent;
  border: solid transparent;
  color: transparent;
}
input[type="range"]::-ms-fill-lower {
  background-color: #ff077b;
}
input[type="range"]::-ms-fill-upper {
  background: #ff077b;
}
input[type="range"]::-ms-thumb {
  box-sizing: content-box;
  border: 1px solid #ff077b;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
}
input[type="range"]:active::-ms-thumb {
  transform: scale(1.2);
  background: #ff077b;
}

.audio-player {
  height: 50px;
  width: 350px;
  background: #444;
  box-shadow: 0 0 20px 0 #000a;

  font-family: arial;
  color: white;
  font-size: 0.75em;
  overflow: hidden;

  display: grid;
  grid-template-rows: 6px auto;
  .timeline {
    background: white;
    width: 100%;
    position: relative;
    cursor: pointer;
    box-shadow: 0 2px 10px 0 #0008;
    .progress {
      background: coral;
      width: 0%;
      height: 100%;
      transition: 0.25s;
    }
  }
  .controls {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    padding: 0 20px;

    > * {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .toggle-play {
      &.play {
        cursor: pointer;
        position: relative;
        left: 0;
        height: 0;
        width: 0;
        border: 7px solid #0000;
        border-left: 13px solid white;
        &:hover {
          transform: scale(1.1);
        }
      }
      &.pause {
        height: 15px;
        width: 20px;
        cursor: pointer;
        position: relative;
        &:before {
          position: absolute;
          top: 0;
          left: 0px;
          background: white;
          content: "";
          height: 15px;
          width: 3px;
        }
        &:after {
          position: absolute;
          top: 0;
          right: 8px;
          background: white;
          content: "";
          height: 15px;
          width: 3px;
        }
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    .time {
      display: flex;

      > * {
        padding: 2px;
      }
    }
    .volume-container {
      cursor: pointer;
      .volume-button {
        height: 26px;
        display: flex;
        align-items: center;
        .volume {
          transform: scale(0.7);
        }
      }

      position: relative;
      z-index: 2;
      .volume-slider {
        position: absolute;
        left: -3px;
        top: 15px;
        z-index: -1;
        width: 0;
        height: 15px;
        background: white;
        box-shadow: 0 0 20px #000a;
        transition: 0.25s;
        .volume-percentage {
          background: coral;
          height: 100%;
          width: 75%;
        }
      }
      &:hover {
        .volume-slider {
          left: -123px;
          width: 120px;
        }
      }
    }
  }
}
.uploaded-audio {
  padding: 23px 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-top: 16px;

  .audio-info {
    .icon {
      cursor: pointer;
    }
    .text {
      .title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #313c4e;
        margin: 0;
      }
      .duration {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #313c4e;
        display: flex;
        align-items: center;
        margin: 0;

        span {
          color: var(--accent-color);
          margin-left: 10px;
        }
      }
    }
  }

  .actions {
    .title {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: var(--accent-color);
      margin-right: 10px;
    }
    .icon {
      cursor: pointer;
    }
  }

  .playing-audio {
    display: flex;
    align-items: center;
    .stop-btn {
      background: none;
      border: none;
      padding: 0;
    }
    .seeker {
      width: 100%;
      margin-left: 14px;
      width: 100%;
      padding-top: 11px;
      padding-right: 6px;
      .player-controls {
        span {
          width: 100%;
          order: 2;
          display: flex;
          border: none !important;
          position: relative;

          .seekbar {
            position: absolute;
            top: -10px;
            border-radius: 50%;
            height: 23px;
            width: 23px;
            background: var(--accent-color);
            cursor: pointer;
            // transition: 1s all;
          }
        }

        progress {
          width: 100%;
          cursor: pointer;
        }

        small {
          display: flex;
          margin-right: 10px;
          font-family: "Poppins", sans-serif;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          margin-top: 15px;
          position: relative;
          margin-bottom: -10px;
        }

        #start-time {
          float: left;
          position: relative;
          order: 0;
          margin-right: 0px;
          font-family: "Poppins", sans-serif;
          font-weight: 500;
          font-size: 16px;
          color: #565656;
        }

        .end-time {
          position: relative;
          order: 3;
          margin-left: 0px;
          font-family: "Poppins", sans-serif;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          min-width: 40px;
          justify-content: flex-end;
        }

        progress[value] {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background-color: #ccc;
          color: var(--accent-color);
          height: 3px;
        }

        progress[value]::-webkit-progress-bar {
          background-color: #ccc;
          border-radius: 2px;
          color: var(--accent-color);
        }

        progress::-webkit-progress-value {
          background-color: var(--accent-color);
        }

        progress::-moz-progress-bar {
          background-color: #ccc;
        }

        p {
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>
